module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-144x144-3b84bec07d614345d535d9e60f891c88.png";